import { useEffect, useMemo } from "react";

export default function PdfViewerModal({ open, title, source, onClose, onDownload }) {
  const safeTitle = useMemo(() => title || "Submission PDF", [title]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="pdf-viewer-overlay" onClick={onClose}>
      <div className="pdf-viewer-modal" onClick={(event) => event.stopPropagation()}>
        <div className="pdf-viewer-header">
          <div className="pdf-viewer-title-wrap">
            <strong className="pdf-viewer-title">{safeTitle}</strong>
            <span className="pdf-viewer-subtitle">Native PDF Viewer</span>
          </div>
          <div className="pdf-viewer-actions">
            <button className="toolbar-btn" onClick={onDownload}>Download</button>
            <button className="toolbar-btn danger" onClick={onClose}>Close</button>
          </div>
        </div>
        <div className="pdf-viewer-body">
          {source?.url ? (
            <iframe
              title={safeTitle}
              src={`${source.url}#toolbar=0&navpanes=0&scrollbar=1&statusbar=0&messages=0`}
              className="pdf-viewer-frame"
            />
          ) : (
            <p className="submit-error">Unable to load PDF.</p>
          )}
        </div>
      </div>
    </div>
  );
}
